import { LowercaseLanguageCode } from '../../constants/Enums';

export const getXDefaultLanguage = (alternateLanguages, actualLanguage) => {
  const allLanguages = alternateLanguages.concat([actualLanguage]);
  const languagePriority = [
    LowercaseLanguageCode.EN,
    LowercaseLanguageCode.FR,
    LowercaseLanguageCode.ES,
    LowercaseLanguageCode.DE,
    LowercaseLanguageCode.IT,
  ];

  for (const lang of languagePriority) {
    const match = allLanguages.find(e => e.lang.includes(lang));
    if (match) {
      return match;
    }
  }

  return null;
};
